(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-verification"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('#AgeVerification');
    const storageKey = 'der-wohnsinnige-age-verification';
    const validityPeriod = 30 * 24 * 60 * 60 * 1000;

    if (!dialog) return;

    const hideDialog = () => {
      dialog.close();
      dialog.remove();
    };

    try {
      const confirmedAt = Number(window.localStorage.getItem(storageKey));
      if (confirmedAt && Date.now() - confirmedAt < validityPeriod) {
        hideDialog();
        return;
      }
    } catch (error) {
    }

    dialog.showModal();

    dialog.querySelector('[data-age-verify="confirm"]').addEventListener('click', () => {
      try {
        window.localStorage.setItem(storageKey, String(Date.now()));
      } catch (error) {
      }
      hideDialog();
    });

    dialog.querySelector('[data-age-verify="decline"]').addEventListener('click', () => {
      window.location.assign(window.location.origin + '/');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
